import PropTypes from 'prop-types';
import useCreateInvoiceTaxAuthorityConfig from 'Hooks/useCreateInvoiceTaxAuthorityConfig';
import useWorkspaceSelected from 'Hooks/useWorkspaceSelected';
import InvoicesTaxAuthorityConfigVerifactuForm from './InvoicesTaxAuthorityConfigVerifactuForm';
import InvoicesTaxAuthorityConfigTicketbaiForm from './InvoicesTaxAuthorityConfigTicketbaiForm';

const VERIFACTU_DEFAULT_VALUES = {
    country: 'ESP',
    invoice_subtype: null,
    contact_type: null,
    contact_id: null,
    es_verifactu_doc_type: null,
    simplified_art7273_bool: false,
    es_verifactu_issuer_type: null,
    representative_name: null,
    representative_tax_id: null,
    representative_country: 'ESP',
    es_verifactu_regime: '01',
};

const TICKETBAI_DEFAULT_VALUES = {
    country: 'ESP',
    invoice_subtype: null,
    contact_type: null,
    contact_id: null,
    es_tbai_doc_type: null,
    es_tbai_issuer_type: null,
    es_tbai_regime: '01',
};

export default function InvoicesTaxAuthorityConfigCreateDrawer({ onClose, onSubmit, onError }) {
    const { createConfig } = useCreateInvoiceTaxAuthorityConfig();
    const { workspace } = useWorkspaceSelected();

    const formProps = {
        onSave: (params) => createConfig(params),
        onClose,
        onSuccess: onSubmit,
        onError,
    };

    if (workspace?.tax_authority === 'ticketbai') {
        return <InvoicesTaxAuthorityConfigTicketbaiForm defaultValues={TICKETBAI_DEFAULT_VALUES} {...formProps} />;
    }

    return <InvoicesTaxAuthorityConfigVerifactuForm defaultValues={VERIFACTU_DEFAULT_VALUES} {...formProps} />;
}

InvoicesTaxAuthorityConfigCreateDrawer.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
};
